"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initLogAndManager = exports.ConnectionLog = void 0;
/**
 * 连接层日志打印模块（有数量限制，重连超过5次停止打日志）
 *
 * @export
 * @class ConnectionLog
 */
var ConnectionLog = {
    ConnectionLogModule: 'ConnectionLog',
    liteReconnects: 0,
    needSaveLog: function () {
        if (ConnectionLog.liteReconnects < 5) {
            return true;
        }
        return false;
    },
    debug: function () { },
    info: function () { },
    warn: function () { },
    error: function () { },
};
exports.ConnectionLog = ConnectionLog;
/**
 * 外部模块需要通过initLogAndManager初始化Log模块
 *
 * @param {ILogDependency} dependency
 */
function initLogAndManager(dependency) {
    if (dependency) {
        ConnectionLog.debug = function (data) {
            var _a;
            if (ConnectionLog.needSaveLog()) {
                (_a = dependency.debug) === null || _a === void 0 ? void 0 : _a.call(dependency, ConnectionLog.ConnectionLogModule, data);
            }
        };
        ConnectionLog.info = function (data) {
            var _a;
            if (ConnectionLog.needSaveLog()) {
                (_a = dependency.info) === null || _a === void 0 ? void 0 : _a.call(dependency, ConnectionLog.ConnectionLogModule, data);
            }
        };
        ConnectionLog.warn = function (data) {
            var _a;
            if (ConnectionLog.needSaveLog()) {
                (_a = dependency.warn) === null || _a === void 0 ? void 0 : _a.call(dependency, ConnectionLog.ConnectionLogModule, data);
            }
        };
        ConnectionLog.error = function (data) {
            var _a;
            if (ConnectionLog.needSaveLog()) {
                (_a = dependency.error) === null || _a === void 0 ? void 0 : _a.call(dependency, ConnectionLog.ConnectionLogModule, data);
            }
        };
    }
}
exports.initLogAndManager = initLogAndManager;
